import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Maintenance',
  tagline: 'Keep Your Website Healthy',
  icon: '🔧',
  heroDesc: 'Your website needs regular care to stay secure, fast, and up-to-date. Our website maintenance plans ensure your online presence is always performing at its best — so you can focus on your business.',
  mainStat: '99.9%',
  mainStatLabel: 'Average uptime for all websites under our maintenance',
  subStats: [{ value: '24/7', label: 'Uptime Monitoring' }, { value: '<4hr', label: 'Response Time for Issues' }],
  features: [
    { icon: '🔄', title: 'Regular Updates', desc: 'WordPress core, theme, and plugin updates to keep your site secure and compatible.' },
    { icon: '💾', title: 'Daily Backups', desc: 'Automated daily backups stored securely so your data is always recoverable.' },
    { icon: '🔒', title: 'Security Monitoring', desc: 'Active scanning for malware, vulnerabilities, and unauthorized access attempts.' },
    { icon: '⚡', title: 'Performance Optimization', desc: 'Regular speed audits and optimizations to maintain fast loading times.' },
    { icon: '📊', title: 'Monthly Reports', desc: 'Detailed reports on uptime, security status, speed scores, and updates completed.' },
    { icon: '🛠️', title: 'Bug Fixes & Minor Changes', desc: 'Small content updates, bug fixes, and minor design tweaks included in maintenance.' },
  ],
  benefits: [
    { title: 'Always Secure', desc: 'Outdated plugins and themes are the #1 cause of website hacks. Regular updates protect your site.' },
    { title: 'Consistent Performance', desc: 'Regular optimization ensures your website continues to load fast as content grows.' },
    { title: 'Peace of Mind', desc: 'Know that professionals are watching over your website 24/7 so you never have to worry.' },
    { title: 'Cost Savings', desc: 'Preventive maintenance is far cheaper than emergency fixes after a hack or crash.' },
  ],
  process: [
    { title: 'Website Audit', desc: 'Complete health check of your current website including security, speed, and plugin status.' },
    { title: 'Maintenance Plan Setup', desc: 'Backup schedules, monitoring tools, and update protocols configured and activated.' },
    { title: 'Monthly Maintenance Cycle', desc: 'Updates, backups, security scans, and performance checks performed each month.' },
    { title: 'Issue Resolution', desc: 'Any problems found during maintenance are resolved promptly within our SLA.' },
    { title: 'Monthly Report Delivery', desc: 'Comprehensive report delivered to you every month with all activities completed.' },
  ],
  whyChoose: [
    { icon: '🛡️', title: 'Proactive Protection', desc: 'We fix issues before they become problems — not after your site goes down.' },
    { icon: '📞', title: 'Priority Support', desc: 'Maintenance clients get priority response times for any urgent issues.' },
    { icon: '👨‍💻', title: 'Expert Team', desc: 'Experienced developers who understand the technical details of your website.' },
    { icon: '📋', title: 'Full Transparency', desc: 'Monthly reports detail exactly what was done, found, and fixed on your website.' },
  ],
  reviews: [
    { name: 'Mukesh Bansal', role: 'Hospital Group', text: 'Our website was hacked before we found DMS. Since handing maintenance to them, zero issues in 2 years.' },
    { name: 'Kaveri Singh', role: 'School Principal', text: 'The monthly reports give us complete confidence that our school website is in safe hands.' },
    { name: 'Rajan Shetty', role: 'Hotel Chain', text: 'Website speed has improved dramatically since DMS took over maintenance. Guests comment on it!' },
  ],
  faq: [
    { q: 'What if my website gets hacked?', a: 'We provide emergency malware removal and site restoration as part of our maintenance plans.' },
    { q: 'Do you maintain WordPress and non-WordPress sites?', a: 'We primarily specialize in WordPress maintenance but also support HTML/CSS and custom CMS websites.' },
    { q: 'How many content changes are included?', a: 'Our maintenance plans include up to 2 hours of minor content updates per month. Additional hours are billed separately.' },
  ],
};

export default function WebsiteMaintenance() {
  return <ServiceTemplate data={data} />;
}
